import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdService, ServedAd } from '@app/services/ad.service';

@Component({
  selector: 'app-ad-native',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (ad) {
      <div class="ad-native" (click)="onClick()">
        <span class="ad-native-label">Sponsored</span>
        <div class="ad-native-body">
          <div class="ad-native-image">
            @if (ad.imageUrl) {
              <img [src]="ad.imageUrl" [alt]="ad.headline">
            } @else {
              {{ (ad.headline || 'Ad').substring(0, 2) }}
            }
          </div>
          <div class="ad-native-text">
            <span class="ad-native-headline">{{ ad.headline }}</span>
            <span class="ad-native-desc">{{ ad.description }}</span>
            <span class="ad-native-url">{{ ad.displayUrl || ad.destinationUrl }}</span>
          </div>
        </div>
      </div>
    }
  `,
  styles: [`
    .ad-native {
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      overflow: hidden;
      background: #fff;
      cursor: pointer;
      transition: border-color 0.15s;
    }
    .ad-native:hover { border-color: #93c5fd; }

    .ad-native-label {
      display: block;
      font-size: 10px; font-weight: 500; color: #9ca3af;
      text-transform: uppercase; letter-spacing: 0.05em;
      padding: 8px 12px 0;
    }

    .ad-native-body { display: flex; gap: 12px; padding: 8px 12px 12px; }

    .ad-native-image {
      width: 80px; height: 80px; border-radius: 6px;
      background: linear-gradient(135deg, #1565C0, #42A5F5);
      flex-shrink: 0; display: flex; align-items: center; justify-content: center;
      color: white; font-size: 16px; font-weight: 600; overflow: hidden;
    }
    .ad-native-image img { width: 100%; height: 100%; object-fit: cover; }

    .ad-native-text { flex: 1; min-width: 0; }
    .ad-native-headline { display: block; font-size: 14px; font-weight: 500; color: #1a1a1a; margin-bottom: 4px; }
    .ad-native-desc {
      display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
      overflow: hidden; font-size: 12px; color: #6b7280; line-height: 1.4;
    }
    .ad-native-url { display: block; font-size: 11px; color: #1565C0; margin-top: 4px; }
  `]
})
export class AdNativeComponent implements OnInit {
  @Input() placement = '';
  private adService = inject(AdService);
  ad: ServedAd | null = null;

  ngOnInit() {
    this.adService.getAd(this.placement).subscribe(ad => this.ad = ad);
  }

  onClick() {
    if (this.ad) this.adService.recordClick(this.ad);
  }
}
